import * as Yup from 'yup';

export default Yup.object().shape({
  id: Yup.string()
    .matches(/^[a-zA-Z0-9]+$/, 'login_resend_form_wm_id_not_matching')
    .required('login_resend_form_wm_id_required'),
});
